var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "report-statement"
  }, [_c("a-alert", {
    attrs: {
      type: "info"
    }
  }, [_c("template", {
    slot: "message"
  }, [_vm._v(" " + _vm._s(_vm.$t("导出说明")) + " ： "), _c("span", [_vm._v(_vm._s(_vm.$t("1、导出数据时间范围最多选择3个月，如导出周期过长请分批导出")) + " ；")]), _c("br"), _c("span", {
    staticClass: "msg-font"
  }, [_vm._v(_vm._s(_vm.$t("2、确认导出后会自动创建下载任务，请前往“任务列表”查看导出进度")) + " ；")])])], 2), _c("a-spin", {
    attrs: {
      tip: _vm.$t("加载中..."),
      spinning: _vm.isLoading
    }
  }, [_c("h2", [_vm._v(_vm._s(_vm.$t("选择导出的列表")))]), _c("a-radio-group", {
    on: {
      change: _vm.onChangeExportList
    },
    model: {
      value: _vm.exportType,
      callback: function ($$v) {
        _vm.exportType = $$v;
      },
      expression: "exportType"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("保单列表")))]), _c("a-radio", {
    attrs: {
      value: 2
    }
  }, [_vm._v(_vm._s(_vm.$t("订单列表")))]), _c("a-radio", {
    attrs: {
      value: 3
    }
  }, [_vm._v(_vm._s(_vm.$t("理赔记录")))])], 1), _vm.exportType ? _c("h2", [_vm._v(_vm._s(_vm.$t("选择导出的信息")))]) : _vm._e(), _vm.exportType ? _c("a-form-model", {
    ref: "exportForm",
    attrs: {
      model: _vm.form,
      layout: "inline",
      rules: _vm.rule
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("导出时间"),
      prop: "time"
    }
  }, [_c("a-range-picker", {
    staticStyle: {
      width: "360px"
    },
    attrs: {
      format: _vm.getFormatDate() + " HH:mm:ss" + _vm.dateChronaxie(),
      "disabled-date": _vm.disabledDate,
      "disabled-time": _vm.disabledRangeTime,
      "show-time": {
        hideDisabledOptions: true,
        defaultValue: _vm.defaultValue
      }
    },
    on: {
      change: _vm.onChangeExportTime,
      ok: _vm.okTime,
      openChange: _vm.openChangeDate
    },
    model: {
      value: _vm.form.time,
      callback: function ($$v) {
        _vm.$set(_vm.form, "time", $$v);
      },
      expression: "form.time"
    }
  })], 1), _vm.isCustomer !== 0 ? _c("a-form-model-item", {
    attrs: {
      label: _vm.exportType === 2 ? _vm.$t("订单归属") : _vm.$t("保单归属"),
      prop: "customerId"
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "240px"
    },
    attrs: {
      allowClear: "",
      placeholder: _vm.exportType === 2 ? _vm.$t("请选择") + _vm.$t("订单归属") : _vm.$t("请选择") + _vm.$t("保单归属")
    },
    on: {
      change: _vm.onCustomerIdChange
    },
    model: {
      value: _vm.form.customerId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "customerId", $$v);
      },
      expression: "form.customerId"
    }
  }, _vm._l(_vm.policyAscriptionData, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1) : _vm._e(), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("导出产品"),
      prop: "insuranceId"
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "240px"
    },
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("请选择") + _vm.$t("导出产品")
    },
    on: {
      change: _vm.onProductChange
    },
    model: {
      value: _vm.form.insuranceId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "insuranceId", $$v);
      },
      expression: "form.insuranceId"
    }
  }, _vm._l(_vm.productList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1), _vm.exportType === 1 ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保单状态")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "240px"
    },
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("请选择") + _vm.$t("保单状态")
    },
    model: {
      value: _vm.form.policyState,
      callback: function ($$v) {
        _vm.$set(_vm.form, "policyState", $$v);
      },
      expression: "form.policyState"
    }
  }, _vm._l(_vm.policyStateData, function (item) {
    return _c("a-select-option", {
      key: item.key,
      attrs: {
        value: item.key
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1)], 1) : _vm._e(), _vm.exportType === 1 ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("录单方式")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "240px"
    },
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("请选择") + _vm.$t("录单方式")
    },
    model: {
      value: _vm.form.recordMethod,
      callback: function ($$v) {
        _vm.$set(_vm.form, "recordMethod", $$v);
      },
      expression: "form.recordMethod"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "0"
    }
  }, [_vm._v(_vm._s(_vm.$t("线上出单")))]), _c("a-select-option", {
    attrs: {
      value: "1"
    }
  }, [_vm._v(_vm._s(_vm.$t("手动录单")))]), _c("a-select-option", {
    attrs: {
      value: "2"
    }
  }, [_vm._v(_vm._s(_vm.$t("线下出单")))])], 1)], 1) : _vm._e(), _vm.exportType === 2 ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("订单状态")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "240px"
    },
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("请选择") + _vm.$t("订单状态")
    },
    model: {
      value: _vm.form.orderState,
      callback: function ($$v) {
        _vm.$set(_vm.form, "orderState", $$v);
      },
      expression: "form.orderState"
    }
  }, _vm._l(_vm.orderStateData, function (item) {
    return _c("a-select-option", {
      key: item.key,
      attrs: {
        value: item.key
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1)], 1) : _vm._e(), _vm.exportType === 2 ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("订单类型")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "240px"
    },
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("请选择") + _vm.$t("订单类型")
    },
    model: {
      value: _vm.form.orderType,
      callback: function ($$v) {
        _vm.$set(_vm.form, "orderType", $$v);
      },
      expression: "form.orderType"
    }
  }, _vm._l(_vm.orderTypeData, function (item) {
    return _c("a-select-option", {
      key: item.key,
      attrs: {
        value: item.key
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1)], 1) : _vm._e(), _vm.exportType === 3 ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("审核状态")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "240px"
    },
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("请选择") + _vm.$t("审核状态")
    },
    model: {
      value: _vm.form.claimState,
      callback: function ($$v) {
        _vm.$set(_vm.form, "claimState", $$v);
      },
      expression: "form.claimState"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "pending"
    }
  }, [_vm._v(_vm._s(_vm.$t("待审核")))]), _c("a-select-option", {
    attrs: {
      value: "passed"
    }
  }, [_vm._v(_vm._s(_vm.$t("审核通过")))]), _c("a-select-option", {
    attrs: {
      value: "failure"
    }
  }, [_vm._v(_vm._s(_vm.$t("审核不通过")))])], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm.ifShow && _vm.fixedFieldList.length && _vm.form.time.length ? _c("div", {
    staticClass: "fields-choice"
  }, [_vm.form.time.length ? _c("fields-choose", {
    attrs: {
      data: _vm.fixedFieldList,
      type: _vm.exportType,
      checkedData: _vm.checkedFixedFieldList
    },
    on: {
      changeChecked: _vm.getCheckedList
    }
  }) : _vm._e(), _vm.form.insuranceId && _vm.exportType !== 2 ? _c("label-choose", {
    attrs: {
      data: _vm.tagsData
    },
    on: {
      onChange: _vm.getLabelList
    }
  }) : _vm._e(), _c("a-button", {
    staticClass: "export-btn",
    staticStyle: {
      width: "80px"
    },
    attrs: {
      disabled: _vm.disable,
      type: "primary",
      size: "small"
    },
    on: {
      click: _vm.onExport
    }
  }, [_vm._v(_vm._s(_vm.$t("导 出")))])], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };